<template>
    <div class="modal fade show hotel-modal" aria-labelledby="housekeepingModalTitle">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between align-items-center px-1 my-1">
                    <h1 class="mb-0">Update Room</h1>
                    <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
                </div>

                <hr class="mt-0">

                <div class="modal-body">
                    <div class="row g-2 mb-2">
                        <div class="col-6">
                            <span class="detail-label">Room</span>
                            <div class="detail-value">{{ room.room_name }}</div>
                        </div>
                        <div class="col-6">
                            <span class="detail-label">Reservation No</span>
                            <div class="detail-value">{{ room.reservation_no }}</div>
                        </div>
                    </div>

                    <div class="mb-2">
                        <label class="detail-label mb-1">Date</label>
                        <input type="date" v-model="date" class="form-control">
                    </div>

                    <div class="mb-2">
                        <label class="detail-label mb-1">Description</label>
                        <textarea
                            v-model="description"
                            class="form-control"
                            rows="2"
                            placeholder="Add a note (optional)"
                        ></textarea>
                    </div>

                    <div class="d-flex justify-content-end mt-2">
                        <button type="button" class="btn btn-outline-secondary me-1" @click="closeModal">Cancel</button>
                        <button
                            v-if="allowInspection"
                            type="button"
                            class="btn btn-warning me-1"
                            :disabled="!date || saving"
                            @click="submit('under_inspection')"
                        >
                            Under Inspection
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="!date || saving"
                            @click="submit('completed')"
                        >
                            Completed
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, ref } from 'vue';
import { useRoute } from 'vue-router';
import handleHotel from '@/services/modules/hotel/hotel';
import useDate from '@/services/utils/day';

const props = defineProps({
    room: {
        type: Object,
        required: true,
    },
    allowInspection: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['onClose', 'onDone']);

const $route = useRoute();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { updateHousekeepingRoom } = handleHotel();
const { currentDate } = useDate();

const saving = ref(false);
const date = ref(currentDate());
const description = ref('');

const closeModal = () => {
    emit('onClose');
};

const submit = (completionStatus) => {
    if (!date.value) return;
    if (!props.room.service_general_id) return;
    if (saving.value) return;
    const payload = {
        company_id: $route.params.companyId,
        completion_status: completionStatus,
        date: date.value,
        description: description.value,
    };
    saving.value = true;
    updateHousekeepingRoom(payload, props.room.service_general_id).then(res => {
        if (!res.status) {
            showError(res.message);
            return;
        }
        showSuccess(res.message);
        emit('onDone');
    }).catch(() => {
        showError('Something went wrong');
    }).finally(() => {
        saving.value = false;
    });
};
</script>

<style scoped>
.hotel-modal {
    display: block;
    background: #1c1d1c33;
}
.detail-label {
    display: block;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #98a2b3;
}
.detail-value {
    font-weight: 600;
    color: #101828;
}
</style>
